<app-loading-modal (closed)="onLoadingModalClosed($event)"></app-loading-modal> <!-- [scrollTarget]="nextSectionId" -->

<div class="card card-guide mb-4 mx-auto" *ngIf="!showGuideDetails">
    <img [src]="guide.imageUrl" class="card-img-top" alt="Portada de {{ guide.title }}" />
  
    <div class="card-body text-center">
      <h5 class="guide-title">{{ guide.title }}</h5>
      <p class="guide-description">{{ guide.description }}</p>
  
      <!-- <a [href]="guide.shopifyLink"
         target="_blank"
         class="btn btn-success btn-block btn-lg">
        Comprar ahora →
      </a> -->


        <!-- VIEW DETAILS -->
        <button mat-button (click)="viewGuideDetails(guide)" class="button button-bordered color-light button-round">
          <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isStatus('processing')"></mat-spinner>
          <span *ngIf="!isStatus('processing')">{{'GUIDES.VIEW_DETAILS' | translate}}</span>
        </button>

        <!-- CONTRATAR -->
        <button mat-button (click)="buyProduct(guide.variantLabel)" class="button button-fill color-action button-round">
            <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isStatus('processing')"></mat-spinner>
            <span *ngIf="!isStatus('processing')">{{'GUIDES.BUY_GUIDE' | translate}}</span>
        </button>
  
      <div class="secure-info">
        📩 Recibirás tu guía en PDF por email en minutos tras la compra.
      </div>
    </div>
  </div>